import Vue from 'vue'
import eventCategoryApi from '@/api/eventCategory.api'

const state = {
  categories: {}
}


const getters = {
  eventCategoryById: (state) => (id) => {
    return state.categories[id]
  },

  eventCategories: (state) => {
    return Object.values(state.categories)
  }
}


const actions = {
  async loadEventCategories ({ commit, rootState }) {
    const response = await eventCategoryApi.getEventCategories(rootState.tenant.current)
    commit('SET_EVENT_CATEGORIES', response.data)
  },

  async loadRelations ({ commit, rootState }, id) {
    const response = await eventCategoryApi.getRelations(rootState.tenant.current, id)
    return response.data
  },

  async createEventCategory ({ commit, rootState }, category) {
    const response = await eventCategoryApi.createEventCategory(rootState.tenant.current, category)
    commit('CREATE_EVENT_CATEGORY', response.data)
  },

  async loadAndUpdateEventCategory ({ commit, rootState }, entityData) {
    const response = await eventCategoryApi.getEventCategory(rootState.tenant.current, entityData.entityId)
    commit('UPDATE_EVENT_CATEGORY', response.data)
    return response
  },

  async updateEventCategory ({ commit, rootState }, category) {
    await eventCategoryApi.updateEventCategory(rootState.tenant.current, category.id, category)
    commit('UPDATE_EVENT_CATEGORY', category)
  },

  // async updateEventCategoryByEventCategoryData ({ commit, rootState }, eventCategoryData) {
  //   commit('UPDATE_EVENT_CATEGORY', eventCategoryData)
  // },

  async deleteEventCategory ({ commit, dispatch, rootState }, { id }) {
    await eventCategoryApi.deleteEventCategory(rootState.tenant.current, id)
    commit('DELETE_EVENT_CATEGORY', id)
    // dispatch('event/removeCategoryFromAllEvents', id, { root: true })
  }
}


const mutations = {
  SET_EVENT_CATEGORIES (state, categories) {
    state.categories = {}
    for (const category of categories) {
      Vue.set(state.categories, category.id, category)
    }
  },

  CREATE_EVENT_CATEGORY (state, category) {
    Vue.set(state.categories, category.id, category)
  },

  UPDATE_EVENT_CATEGORY (state, category) {
    Vue.set(state.categories, category.id, category)
  },

  DELETE_EVENT_CATEGORY (state, id) {
    Vue.delete(state.categories, id)
  }
}


export default {
  state,
  getters,
  actions,
  mutations
}
